var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-modal',{attrs:{"name":"shortlist-modal","noBody":"","variant":"grey","focusOnOpen":false},on:{"before-open":_vm.onBeforeOpen}},[_c(_vm.currentTabComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }